/**
 * Is this one of our own automated runs? A leaf module (job #300): useWebActivity asks it on every
 * app open, and reading it out of useWordGame put the whole word game into every learner's boot.
 */

/** Our own automated runs tag themselves: a webdriver browser, ?probe=1, or localStorage ssi_probe=1 (Playwright scripts). */
export function isProbeClient(): boolean {
  try {
    if (navigator.webdriver) return true
    if (new URLSearchParams(location.search).get('probe') === '1') {
      // Persistence is best-effort; a blocked store cannot negate the URL flag.
      try { localStorage.setItem('ssi_probe', '1') } catch { /* storage unavailable */ }
      return true
    }
    return localStorage.getItem('ssi_probe') === '1'
  } catch {
    return !!navigator.webdriver
  }
}
